import { render, staticRenderFns } from "./TradeProductListCard.vue?vue&type=template&id=c2574bc8&"
import script from "./TradeProductListCard.vue?vue&type=script&lang=js&"
export * from "./TradeProductListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports